import { RootState } from "src/shared/types/src";

export const getEymemoryIsLoggedIn = (orderHash?: string) => (
    (state: RootState) => !orderHash ? null : state?.eymemoryLogin?.[orderHash]?.isLoggedIn || false
);

export const getEymemoryLoginData = (orderHash?: string) => (
    (state: RootState) => !orderHash ? null : state?.eymemoryPersistLogin?.[orderHash]?.loginData || null
);

export const getEymemoryOrderDetails = (orderHash?: string) => (
    (state: RootState) => !orderHash ? null : state?.eymemoryLogin?.[orderHash]?.orderDetails || null
);

export const getEymemoryChild = (orderHash?: string) => (
    (state: RootState) => !orderHash ? null : state?.eymemoryLogin?.[orderHash]?.child || null
);

export const getEymemoryNursery = (orderHash?: string) => (
    (state: RootState) => !orderHash ? null : state?.eymemoryLogin?.[orderHash]?.nursery || null
);
